"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const intl_1 = require("@kyruus/intl");
const moment_1 = __importDefault(require("moment"));
const utils_1 = require("../../../lib/utils");
const messages_1 = __importDefault(require("../../../lib/messages"));
const styles_1 = require("./styles");
const PatientStaticInfo = ({ name, dob, gender, address, bannerText, fields }) => {
    const showName = !fields.some((field) => field.type === 'name');
    const showDob = !fields.some((field) => field.type === 'dob');
    // Gender form fields are type `simpleSelect`, need to use path instead
    const showGender = !fields.some((field) => field.path === 'patient.gender');
    const showAddress = !fields.some((field) => field.type === 'address');
    return (react_1.default.createElement(react_1.Fragment, null,
        (showName || showDob || showGender || showAddress) && (react_1.default.createElement(styles_1.Header, null,
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.demographicsFormHeader)))),
        bannerText && react_1.default.createElement(styles_1.InfoBanner, null, bannerText),
        showName && (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(styles_1.Label, null,
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.demographicsFormNameLabel))),
            react_1.default.createElement(styles_1.Text, null, (0, utils_1.toTitleCase)((0, utils_1.makeNameString)(name))))),
        showDob && (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(styles_1.Label, null,
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.demographicsFormDobLabel))),
            react_1.default.createElement(styles_1.Text, null, (0, moment_1.default)(dob).format('MM/DD/YYYY')))),
        showGender && (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(styles_1.Label, null,
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.demographicsFormGenderLabel))),
            react_1.default.createElement(styles_1.Text, null, (0, utils_1.toTitleCase)(gender)))),
        showAddress && (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(styles_1.Label, null,
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.demographicsFormAddressLabel))),
            react_1.default.createElement(styles_1.Text, null,
                address.street1 && react_1.default.createElement("div", null, (0, utils_1.toTitleCase)(address.street1)),
                address.street2 && react_1.default.createElement("div", null, (0, utils_1.toTitleCase)(address.street2)),
                (address.city || address.state || address.zip) && (react_1.default.createElement("div", null,
                    address.city ? `${(0, utils_1.toTitleCase)(address.city)}, ` : null,
                    address.state ? `${address.state.toUpperCase()} ` : null,
                    address.zip ? `${address.zip} ` : null)),
                address.country && react_1.default.createElement("div", null, address.country.toUpperCase()))))));
};
PatientStaticInfo.defaultProps = {
    name: {},
    dob: null,
    gender: null,
    address: {},
    bannerText: null,
    fields: []
};
PatientStaticInfo.propTypes = {
    name: prop_types_1.default.shape({
        first: prop_types_1.default.string,
        middle: prop_types_1.default.string,
        last: prop_types_1.default.string
    }),
    dob: prop_types_1.default.string,
    gender: prop_types_1.default.string,
    address: prop_types_1.default.shape({
        street1: prop_types_1.default.string,
        street2: prop_types_1.default.string,
        city: prop_types_1.default.string,
        state: prop_types_1.default.string,
        zip: prop_types_1.default.string,
        country: prop_types_1.default.string
    }),
    bannerText: prop_types_1.default.string,
    fields: prop_types_1.default.array
};
exports.default = PatientStaticInfo;
//# sourceMappingURL=PatientStaticInfo.js.map